<template>
  <div v-show="!samples_loading" class="animated fadeIn">
    <b-row class="pr-3">
      <b-col :class="classes.col">
        <b-form-group label="Process Type">
          <multiselect
            v-model="selected_process_type"
            :options="process_types"
            :multiple="false"
            track-by="name"
            label="name"
          />
        </b-form-group>
      </b-col>
      <b-col v-if="selected_process_type" :class="classes.col">
        <span v-if="sample_types && sample_types.length === 1">
          {{ handleOne() }}
        </span>
        <b-form-group v-if="sample_types && sample_types.length" label="Sample Type">
          <multiselect
            v-model="selected_sample_type"
            :options="sample_types"
            :multiple="false"
            :open-direction="'bottom'"
            track-by="id"
            label="name"
          />
        </b-form-group>
        <b-alert v-else show class="py-1 mb-3">
          <i :class="classes.i" /> No sample types available.
        </b-alert>
      </b-col>
        <b-col v-if="selected_sample_type" :class="classes.col">
          <template v-if="processes.length">
            <b-form-group label="Process">
              <multiselect
                v-model="selected_process"
                :options="processes"
                :multiple="false"
                :open-direction="'bottom'"
                track-by="id"
                label="name"
              />
            </b-form-group>
          </template>
          <b-alert v-else show class="py-1 mb-3">
            <i :class="classes.i" /> No processes found.
          </b-alert>
        </b-col>
    </b-row>
    <template v-if="process">
      <b-form-group v-if="tasks && tasks.length" label="Task">
        <b-button
          class="mr-1"
          v-for="(task, index) in tasks"
          :variant="checkTask(task)"
          :key="index"
          @click="pickTask(task)"
          >{{ task.name }}</b-button
        >
      </b-form-group>
      <b-alert v-else show class="py-1 mb-0"> No tasks found. </b-alert>
    </template>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "InstrumentRunnerSampleFilter",
  components: {
    Multiselect,
  },
  props: {
    collection: {
      type: Array,
      default: () => [],
    },
    samples_loading: {
      type: Boolean,
      default: true,
    },
    is_grinding: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      classes: {
        col: "pr-0 pb-1 align-self-end",
        i: "fa fa-exclamation-circle",
      },
      process_type: null,
      sample_type: null,
      process: null,
      selected_tasks: [],
      process_types: [
        {
          id: "prep",
          name: "Prep",
        },
        {
          id: "test",
          name: "Testing",
        },
      ],
    };
  },
  computed: {
    sample_types() {
      return this.process_type
        ? this.collection.find(
            ({ name }) => name.toLowerCase() === this.process_type.id
          ).sample_types
        : null;
    },
    processes() {
      return this.sample_type
        ? this.sample_type[`${this.process_type.id}_processes`]
        : null;
    },
    tasks() {
      return this.process
        ? this.process[`${this.process_type.id}_tasks`]
        : null;
    },
    selected_process_type: {
      get() {
        return this.process_type;
      },
      set(value) {
        this.process_type = value;
        this.sample_type = null;
        this.process = null;
        this.selected_tasks = [];
        this.updateFilters();
      },
    },
    selected_sample_type: {
      get() {
        return this.sample_type;
      },
      set(value) {
        this.sample_type = value;
        this.process = null;
        this.selected_tasks = [];
        this.updateFilters();
      },
    },
    selected_process: {
      get() {
        return this.process;
      },
      set(value) {
        this.process = value;
        this.selected_tasks = [];
        this.updateFilters();
      },
    },
  },
  methods: {
    handleOne() {
      /* 
      * select the only option in the dropdown list if only one will exist 
      * use the negative to allow us to go as far down the list as we can 
      */
      if (this.sample_types.length !== 1 || this.sample_type) {
        return;
      }
      this.sample_type = this.sample_types[0];
      
      if (this.processes.length !== 1 || this.process) {
        return;
      }
      this.process = this.processes[0];
      
      if (!this.tasks || (this.tasks.length !== 1 || this.selected_tasks.length)) {
        return;
      }
      this.pickTask(this.tasks[0]);
    },
    updateFilters() {
      const { process_type, sample_type, process, selected_tasks } = this;

      this.$emit("updateSampleFilters", {
        process_type: process_type && process_type.id,
        sample_type: sample_type && sample_type.id,
        process: process && process.id,
        tasks: selected_tasks,
      });
    },
    checkTask({ id }) {
      return this.selected_tasks.find((task) => task === id)
        ? "primary"
        : "light";
    },
    pickTask({ id }) {
      const check = this.selected_tasks.find((task) => task === id);

      this.selected_tasks = check
        ? this.selected_tasks.filter((task) => task !== id)
        : [...this.selected_tasks, id];

      this.updateFilters();
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css" />
